<template>
    <main>
        <div class="row mt-2">
            <div class="list-group mb-3 col-lg-6 col-md-12 col-sm-12" v-for="(item, index) in $v.formulario.$each.$iter" :key="`seccion_${index}`">

                <div  class="card-header py-2 d-flex justify-content-between align-items-center">
                    {{item.$model.nombre}}
                </div>
                <div class="list-group-item" v-for="(pregunta, pIndex) in item.$model.preguntas" :key="`pregunta_${pIndex}`">
                    <div class="d-flex align-items-center justify-content-between">
                        <buttonsCheck 
                            :antecedente="pregunta" 
                            :label="pregunta.nombre" 
                            :type="pregunta.tipo"
                            :validator="$v.formulario.$each[index].preguntas.$each[pIndex].respuesta"
                            v-model="pregunta.respuesta">
                        </buttonsCheck>
                    </div>
                </div>
            </div>
        </div>

        <div class="alert alert-danger text-center" v-if="$v.formulario.$error && $v.formulario.$dirty">Debe completar el formulario</div>

    </main>
</template>
<script>
import buttonsCheck from '../base/baseButtonsCkeck/indexButtonsNoOptions';
import formulariosService from '../../../services/formulariosService';
import respuestasFormulariosService from '../../../services/respuestasFormulariosService';
import {required} from "vuelidate/lib/validators";
import { isEmpty } from 'lodash';
import Toast from '../../../components/common/utilities/toast';

export default {
    props: ['idHistoria', 'finalizada', 'codigo', 'trimestre', 'idUsuario'],
    components: { buttonsCheck },
    data() {
        return {
            type: 'store',
            formulario: [],
            id_formulario: ''
        }
    },
    validations(){
        return {
            formulario : {
                $each : {
                    preguntas:{
                        $each : {
                            respuesta: {required}
                        }
                    }
                }
            }
        }
    },
   methods: {
        async cargarFormulario(){

            try {

                this.LoaderSpinnerShow();

                const response = await formulariosService.showByCode(this.codigo);
                this.id_formulario = response.data.id;

                let respuestas_formulario = await respuestasFormulariosService.showByRespuestableId(
                    {
                        id: this.idHistoria,
                        id_formulario: this.id_formulario,
                        trimestre: this.trimestre !== '' ? this.trimestre : '',
                    }
                );

                if (isEmpty(respuestas_formulario.data) && this.idUsuario) {
                    const last_response = await respuestasFormulariosService.showLastByUser({
                        id_usuario: this.idUsuario,
                        id_formulario: this.id_formulario,
                        codigo_tipo_historia: 'PREC', // Código unificado para todos los clientes
                        id_historia: this.idHistoria,           // Excluye la historia actual para solo traer anteriores
                    });

                    if (!isEmpty(last_response.data)) {
                        respuestas_formulario = last_response;
                    }
                }
                
                const tipoMap = {
                    'TEXTO': 'TEXT',
                    'OPCIONES': 'OPC',
                    'FECHA': 'DATE',
                    'NUMERO': 'NUM'
                };

                this.formulario=response.data.secciones.map(x=>{
                    return {
                        id:x.id,
                        nombre:x.nombre,
                        preguntas:x.preguntas.map(y=>{
                            let respuesta='';
                            if(!isEmpty(respuestas_formulario.data)){
                                respuesta=respuestas_formulario.data.items.find(r=>r.id_pregunta===y.id)?.valor || ''
                            }else{
                                respuesta=y.defaultValue?y.defaultValue : ''
                            }
                            return {
                                ...y,
                                opciones: (y.opciones || []).map(op => {
                                    if (typeof op === 'object' && op !== null) {
                                        return {
                                            ...op,
                                            valor: op.valor || op.texto || op.opcion || ''
                                        };
                                    }
                                    return { id: op, valor: op, texto: op, opcion: op };
                                }),
                                tipo: tipoMap[y.tipo] || y.tipo,
                                respuesta:respuesta,
                            }
                        })
                    }
                });

                this.LoaderSpinnerHide();
            } catch (e) {
                console.error(e);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }
            
        },
        async save() {
            try{

                this.$v.$touch();

                if(this.$v.$invalid) return;

                let respuestas=[];
                
                this.formulario.forEach(x=>{

                    x.preguntas.reduce((t,c) => {
                        let opcion = c.opciones.find(opc=>opc.opcion===c.respuesta || opc.texto===c.respuesta || opc.valor===c.respuesta);
                        return opcion!==undefined?opcion.id:0;
                    },0); 

                    let respuestas_secciones=x.preguntas.map(y=>{
                        let opcion=y.opciones.find(opc=>opc.texto===y.respuesta || opc.opcion===y.respuesta || opc.valor===y.respuesta);
                        return {
                            id_pregunta:y.id,
                            respuesta:y.respuesta,
                            id_opcion:opcion!==undefined?opcion.id:'',
                        }
                    })

                    respuestas.push(...respuestas_secciones);
                });

                let respuestas_historia={
                    id_historia: this.idHistoria,
                    id_formulario:this.id_formulario,
                    respuestas:respuestas,
                    trimestre:this.trimestre
                }

                console.log(respuestas_historia);
        
                this.LoaderSpinnerShow();
                
                await respuestasFormulariosService.store(respuestas_historia);
            
                this.LoaderSpinnerHide();

                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con exito'
                });
            }catch (e) {
                console.error(e);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }  
        }, 
    },
    async created(){
       await this.cargarFormulario();
    },
    watch: {
        trimestre: async function (value){ 
            if(value){
                this.cargarFormulario();                
            }
        }
    },

}
</script>